import React from 'react';
import { inputBase, inputFocused } from './inputStyles';

export default function DarkSelect({ children, style = {}, ...props }) {
  const [focused, setFocused] = React.useState(false);
  return (
    <select
      {...props}
      style={{ ...inputBase, ...(focused ? inputFocused : {}), cursor: 'pointer', ...style }}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
    >
      {children}
    </select>
  );
}
